.column {
	display: flex;
	flex-direction: column;

	/* Plain, unfilled lane — matching the live board (bordered cards carry the structure),
	   not a muted filled card (James's 2026-09-03 call). */

	/* Board header chrome: an uppercase label with a right-aligned count. */
	& header {
		display: flex;
		gap: var(--spacing-2);
		align-items: center;
		padding: var(--spacing-2) 0 var(--spacing-3);

		& h2 {
			margin: 0;
			font-size: var(--font-size-xs);
			font-weight: var(--font-weight-semibold);
			color: var(--colour-text-secondary);
			text-transform: uppercase;
			letter-spacing: var(--letter-spacing-wide);
		}
	}

	& .count {
		margin-inline-start: auto;
		font-size: var(--font-size-xs);
		font-weight: var(--font-weight-semibold);
		font-variant-numeric: tabular-nums;
		color: var(--colour-text-tertiary);
	}

	/* Content-width, not the full-width quick-add slot, so it reads as an action —
	   matching the board's archive-done control. */
	& .archive {
		align-self: flex-start;
		margin-block-end: var(--spacing-2);

		& .archiveIcon {
			inline-size: 0.875rem;
			block-size: 0.875rem;
		}
	}

	& .stack {
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: var(--spacing-3);
		min-block-size: 2rem;
	}

	/* Zero-height, with its extra flex gap cancelled, so showing it shifts no cards; the
	   visible 2px line sits centred in the gap above it. */
	& .dropLine {
		position: relative;
		block-size: 0;
		margin-block-end: calc(var(--spacing-3) * -1);

		&::after {
			position: absolute;
			inset-block-start: calc(var(--spacing-3) / -2 - 1px);
			inset-inline: 0;
			block-size: 2px;
			content: '';
			background: var(--colour-brand-primary);
			border-radius: var(--radius-full);
		}
	}

	& .empty {
		padding: var(--spacing-1-5) var(--spacing-1);
		margin: 0;
		font-size: var(--font-size-xs);
		color: var(--colour-text-tertiary);
	}
}
